<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-prompt
      title="Add new Post"
      @cancel="val = ''"
      @accept="acceptAddWallPostPrompt"
      @close="closeAddWallPostPrompt"
      :active.sync="addWallPostPrompt"
    >
      <div>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-5/5 w-full">
            <i8n-input label="Title" :content.sync="newWallPostTitle" class="mt-5 w-full" name="item-name" v-validate="'required'" />
          </div>
        </div>
      </div>
    </vs-prompt>

    <h3>Wall</h3>

    <vs-table 
      ref="table" 
      class="mt-8" 
      v-model="selected" 
      pagination 
      :max-items="itemsPerPage" 
      search 
      :data="wallPosts"
      @selected="onWallPostClicked(selected.newsId)">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ADD NEW -->
          <div @click="addWallPostPrompt = true" class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add new Post</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ wallPosts.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : wallPosts.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="title">Title</vs-th>
        <vs-th>Author</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.title }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.author.displayName }}</p>
              </vs-td>

              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="onWallPostClicked(tr.newsId)" />
                <!--<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
    return {
      addWallPostPrompt: false,
      newWallPostTitle: null,

      query: '*',

      wallPosts: [],

      selected: [],
      itemsPerPage: 100,
      isMounted: false,
    }
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.wallPosts.length
    }
  },
  methods: {
    acceptAddWallPostPrompt() {
      this.$vs.loading();

      const url = process.env.VUE_APP_API + "/News";

      const payload = {
        title: this.newWallPostTitle
      };

      this.$http
        .post(url, payload)
        .then((resp) => {
          this.$vs.notify({
            color: "success",
            title: "Success",
            text: "Wall Post draft added",
          });

          this.$router.push({ name: 'admin-wall-post', params: { wallPostId: resp.data.postId } }).catch(() => {})
        })
        .catch((err) => {
          console.log(err);

          this.$vs.notify({
            color: "danger",
            title: "Error",
            text: "Could not add Wall Post draft: " + err,
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    closeAddWallPostPrompt() {},

    getWallPosts: function () {
      this.$vs.loading()

      this.$http.get(process.env.VUE_APP_API +'/News?query=' + this.query)
        .then(resp => {
          console.log(resp.data);
          this.wallPosts = resp.data;
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.$vs.loading.close()
        })
    },

    onWallPostClicked(newsId) {
      this.$router.push({ name: 'admin-wall-post', params: { wallPostId: newsId } }).catch(() => {})
    },


    addNewData () {
    },
    deleteData (id) {
      console.log("Delete:", id);
    },
    editData (data) {
      console.log("Edit:", data);
    },
    getNumParticipantsColor (numParticipants) {
      if (numParticipants == 0) return 'warning'
      return 'success'
    }
  },
  created () {
    this.getWallPosts();
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>